export type TValueSize = 'primary' | 'secondary' | 'caption';

/**
 * Подсказка для интерпретации данных. Например для месяца тип данных - date, а SemanticType - MONTH
 * todo требует доописания и обсуждение. Например нужен ли тип ID
 * @link https://developers.google.com/datastudio/connector/reference#semantictype
 */
export enum ValueSemanticType {
  // дата и время
  DATE_TIME = 'DATE_TIME',
  // дата
  DATE = 'DATE',
  YEAR = 'YEAR',
  YEAR_QUARTER = 'YEAR_QUARTER',
  YEAR_MONTH = 'YEAR_MONTH',
  YEAR_WEEK = 'YEAR_WEEK',
  YEAR_MONTH_DAY = 'YEAR_MONTH_DAY',
  YEAR_MONTH_DAY_HOUR = 'YEAR_MONTH_DAY_HOUR',
  QUARTER = 'QUARTER',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  MONTH_DAY = 'MONTH_DAY',
  // день недели теекстом
  DAY_OF_WEEK = 'DAY_OF_WEEK',

  // Длительность (интервал)
  DURATION = 'DURATION',

  /**
   * Удобно указать TEXT для полей со ссылками на другие entity,
   * так как с этими данными редко или никогда не работают как с числами в прале арифметических операций.
   * Например редко кто будет сравнивать userId операциями "больше" или "меньше",
   * обычно с ними работает как с текстами - "IN", "=", "!=" и выполняют операции группировки по таким полям
   */
  TEXT = 'TEXT',

  LONG_TEXT = 'LONG_TEXT',

  HTML = 'HTML',

  /**
   * Поде типа email, а значит к нему применяются повышенные требоваия к безопасности
   */
  EMAIL = 'EMAIL',

  /** Число "как есть" */
  NUMBER = 'NUMBER',

  /** Число без точки с запятой */
  NUMBER_INT = 'NUMBER_INT',

  /** Число с обязательным 1 знаком после запятой. Даже если там ноль */
  NUMBER_FRACTION_DIGITS_1 = 'NUMBER_FRACTION_DIGITS_1',

  /** Число с обязательными 2 знаками после запятой. Даже если там нули */
  NUMBER_FRACTION_DIGITS_2 = 'NUMBER_FRACTION_DIGITS_2',

  BOOLEAN = 'BOOLEAN',

  /** Ок - зеленое, Не ок - красное */
  BOOLEAN_TWO_VARIANTS = 'BOOLEAN_TWO_VARIANTS',

  URL = 'URL',

  /**
   * При установке такого типа обязательно должно быть заполнено свойство media у поля
   */
  MEDIA = 'MEDIA',

  /**
   * Говорит о том, что поле содержит какую-то строку таблицы (объект или его часть)
   */
  RECORD = 'RECORD',

  /**
   * Поля является json-ом с предикатом в формате auto api
   */
  PREDICATE = 'PREDICATE',

  /**
   * Используется для отображения вложенных React компонентов
   */
  JSX = 'JSX',
}
